import useAxiosAuthentication from "@/compositions/useAxiosAuthentication";
import axios, { type AxiosRequestConfig } from "axios";
import { DEFAULT_HEADERS } from "@/compositions/useAxios/data.ts";

// Consent is owned by isce-tenant-service and reached directly via the tenant base URL
// (the isce-tenant APIGEE proxy), not through the track-and-trace `/v1` base.
const CONSENTS_URL = `${import.meta.env.VITE_API_TENANT_BASE_URL}/users/consents`;

const axiosInstance = axios.create();
useAxiosAuthentication(axiosInstance);

const tenantHeaders = (config?: AxiosRequestConfig) => ({
  ...config?.headers,
  ...DEFAULT_HEADERS,
  "api-key": import.meta.env.VITE_TENANT_API_KEY
});

// Returns the full axios response (callers destructure `{ data }`), matching the
// previous crudFactory `getAll` behaviour so consuming code is unchanged.
const getAll = async <T>(config?: AxiosRequestConfig): Promise<T> => {
  const response = await axiosInstance.get<T>(CONSENTS_URL, {
    ...config,
    headers: tenantHeaders(config)
  });
  return response as unknown as T;
};

const createOne = async <T>(data: unknown, config?: AxiosRequestConfig): Promise<T> => {
  const response = await axiosInstance.post<T>(CONSENTS_URL, data, {
    ...config,
    headers: tenantHeaders(config)
  });
  return response.data;
};

export default { getAll, createOne };
